import {UserDetailDto, UserService} from "../../api/psc.ts";
import DialogContainer from "../../components/DialogContainer";
import DialogHeader from "../../components/DialogHeader";
import {Alert, Box, Button, Stack, TextField} from "@mui/material";
import {ChangeEvent, useContext, useState} from "react";
import {DialogContext} from "../../contexts/DialogueContext";

export default function SetPasswordDialog(props: { user: UserDetailDto }) {

    const {closeDialog} = useContext(DialogContext)

    const [requestInProgress, setRequestInProgress] = useState(false)
    const [password, setPassword] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')
    const [error, setError] = useState<string | null>(null)

    const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    }

    const handlePasswordConfirmationChange = (event: ChangeEvent<HTMLInputElement>) => {
        setPasswordConfirmation(event.target.value);
    }

    const submit = () => {
        if (password !== passwordConfirmation) {
            setError('رمز عبور با رمز نکرار رمز عبور مطابقت ندارد')
            return
        }
        setError(null)
        UserService.setPassword(props.user.id, {
            password: password
        }).then(r => {
            setRequestInProgress(false)
            closeDialog()
        }).finally(() => {
            setRequestInProgress(false)
        })
    }

    return <DialogContainer>
        <DialogHeader title='تغییر رمز عبور'/>
        <Stack sx={{p: 2}} spacing={2}>
            <TextField label='رمز عبور' type='password' value={password} onChange={handlePasswordChange}/>
            <TextField label='تکرار رمز عبور' type='password' value={passwordConfirmation} onChange={handlePasswordConfirmationChange}/>

            {
                error &&
                <Alert severity='error'>
                    {error}
                </Alert>
            }

            <Button disabled={requestInProgress} onClick={submit} variant='contained'>
                اعمال رمز عبور جدید
            </Button>
        </Stack>
    </DialogContainer>
}
